/** Socket.IO event names emitted by the backend. */
export const SOCKET_EVENTS = {
  /** Unified channel message create — admin/member/Aria. Envelope uses `data`. */
  MESSAGE_NEW: 'message:new',
  /** Chat reaction fanout — same envelope/rooms as message:new. */
  MESSAGE_REACTION_ADDED: 'message:reaction_added',
  MESSAGE_REACTION_REMOVED: 'message:reaction_removed',
  PARTNER_GROUP_CHAT_MESSAGE: 'partner:group_chat:message',
  PARTNER_GROUP_CHAT_REACTION: 'partner:group_chat:reaction',
  PARTNER_TEMPORARY_DISABLE_UPDATED: 'partner:temporary_disable:updated',
};
